import update from 'immutability-helper';
import _ from 'lodash';
import enums from '../common/utils/enums';
import I18n from '../../config/i18n';
import qwPartners from '../common/clients/qwPartners';
import { handleAppError } from './app';
import { showAppBusy, showAppError } from './app';

const initialState = {
  appliances: [],
  appliance: {},
  isApplianceSwitched: false,
  isApplianceStatusLoading: false,
};
const RECEIVE = 'appliances/RECEIVE';
const UPDATE_ACTIVE_APPLIANCE = 'appliances/UPDATE_ACTIVE_APPLIANCE';
const IS_APPLIANCE_SWITCHED = 'appliances/IS_APPLIANCE_SWITCHED';
const IS_APPLIANCE_STATUS_LOADING = 'appliances/IS_APPLIANCE_STATUS_LOADING';

export const receiveAppliances = (appliances) => {
  return { type: RECEIVE, payload: appliances };
};

export const updateActiveAppliance = (appliance) => {
  return { type: UPDATE_ACTIVE_APPLIANCE, payload: appliance };
};

export const updateApplianceState = (applianceState) => {
  return (dispatch, getState) => {
    const { appliances } = getState().appliances;
    const appliance = applianceState.data.systemState;

    const updatedApplianceIndex = appliances.findIndex(
      (a) => a.applianceId === appliance.applianceId,
    );
    let updatedAppliance = _.cloneDeep(appliances[updatedApplianceIndex]);
    updatedAppliance = update(updatedAppliance, {
      drives: { $set: _.sortBy(appliance.drives, 'bay') },
    });
    const updatedAppliances = update(appliances, {
      $splice: [[updatedApplianceIndex, 1, updatedAppliance]],
    });

    dispatch(receiveAppliances(_.cloneDeep(updatedAppliances)));
    dispatch(updateActiveApplianceFromAppliances());
    dispatch(showAppBusy(false));
  };
};

export const updateApplicanceStatus = (applianceStatus) => {
  return (dispatch, getState) => {
    const { appliances } = _.cloneDeep(getState().appliances);
    const appliancesStatus = applianceStatus.data.applianceStatus.appliances;

    appliances.forEach((appliance) => {
      appliancesStatus.forEach((applianceStatus) => {
        if (appliance.applianceId === applianceStatus.applianceId) {
          appliance.activeDownloads = applianceStatus.activeDownloads;
          appliance.downloadRate = applianceStatus.downloadRate;
          appliance.isOnline = applianceStatus.isOnline;
          appliance.softwareVersion = applianceStatus.softwareVersion;
          appliance.publicIp = applianceStatus.publicIp;
        }
      });
    });
    dispatch(receiveAppliances(_.cloneDeep(appliances)));
    dispatch(updateActiveApplianceFromAppliances());
    dispatch(showAppBusy(false));
  };
};

export const toggleIsApplianceSwitch = (isApplianceSwitched) => {
  return { type: IS_APPLIANCE_SWITCHED, payload: isApplianceSwitched };
};

export const toggleIsApplianceStatusLoading = (isApplianceStatusLoading) => {
  return {
    type: IS_APPLIANCE_STATUS_LOADING,
    payload: isApplianceStatusLoading,
  };
};

const updateActiveApplianceToAppliances = (updatedAppliance) => {
  return (dispatch, getState) => {
    const { appliances } = getState().appliances;

    const updatedApplianceIndex = appliances.findIndex(
      (appliance) => appliance.applianceId === updatedAppliance.applianceId,
    );
    const updatedAppliances = update(appliances, {
      $splice: [[updatedApplianceIndex, 1, updatedAppliance]],
    });
    dispatch(receiveAppliances(updatedAppliances));
  };
};

const updateActiveApplianceFromAppliances = () => {
  return (dispatch, getState) => {
    const { appliances, appliance } = getState().appliances;
    const updatedApplianceIndex = _.isEmpty(appliance)
      ? 0
      : appliances.findIndex(
          (appl) => appl.applianceId === appliance.applianceId,
        );

    dispatch(updateActiveAppliance(appliances[updatedApplianceIndex]));
  };
};

export const loadAppliances = (showLoading) => {
  return (dispatch) => {
    dispatch(showAppBusy(showLoading));

    return qwPartners
      .get('/v1/appliances')
      .then(({ data: appliances }) => {
        dispatch(showAppBusy(false));
        dispatch(receiveAppliances(appliances));
        dispatch(updateActiveApplianceFromAppliances());
      })
      .catch(() => {
        // dispatch(handleAppError(error, I18n.t('unexpectedError')))
      });
  };
};

export const loadApplianceStatus = (showLoading) => {
  return (dispatch, getState) => {
    const { appliance } = getState().appliances;

    if (!_.isEmpty(appliance)) {
      dispatch(showAppBusy(showLoading));
      dispatch(toggleIsApplianceStatusLoading(true));

      return qwPartners
        .get(`/v1/appliance-status?applianceId=${appliance.applianceId}`)
        .then(({ data: appliance }) => {
          const { isApplianceSwitched } = getState().appliances;

          if (!isApplianceSwitched) {
            dispatch(toggleIsApplianceStatusLoading(true));
            dispatch(updateActiveAppliance(appliance));
            dispatch(updateActiveApplianceToAppliances(appliance));
            dispatch(showAppBusy(false));
          }
          dispatch(toggleIsApplianceSwitch(false));
        })
        .catch(() => {
          // dispatch(handleAppError(error, I18n.t('unexpectedError')))
        });
    }
  };
};

const getCPLFromId = (workOrder, cplId) => {
  return workOrder.compositions.find((c) => c.composition === cplId);
};

const getErrorMessageForDuplication = (errorDetails, appliance, workOrder) => {
  const code = errorDetails.code;
  switch (code) {
    case enums.DuplicationErrors.APPLIANCE_OFFLINE:
      return I18n.t('duplicationErrorsApplianceOffline', {
        serialNo: appliance.serialNo,
      });

    case enums.DuplicationErrors.APPLIANCE_NOT_FOUND:
      return I18n.t('duplicationErrorsApplianceNotFound', {
        serialNo: appliance.serialNo,
      });

    case enums.DuplicationErrors.DRIVE_IN_USE:
      return I18n.t('duplicationErrorsDriveInUse', {
        bayNo: errorDetails.bayNo,
      });

    case enums.DuplicationErrors.DRIVE_NOT_ENOUGH_SPACE:
      return I18n.t('duplicationErrorsDriveNotEnoughSpace', {
        bayNo: errorDetails.bayNo,
      });

    case enums.DuplicationErrors.DCP_NOT_FOUND_IN_APPLIANCE: {
      const cpl = getCPLFromId(workOrder, errorDetails.cplId);
      return I18n.t('duplicationErrorsDcpNotFoundInAppliance', {
        cplName: cpl.cplName,
      });
    }

    case enums.DuplicationErrors.DCP_NOT_FOUND_IN_STORE:
      return I18n.t('dcpIsNotFoundInStore', { bayNo: errorDetails.bayNo });

    case enums.DuplicationErrors.NO_DRIVES_INSERTED:
      return I18n.t('noDrivesInserted');
  }
};

export const startDuplication = (workOrderNo) => {
  return (dispatch, getState) => {
    const { appliance, appliances } = getState().appliances;
    const workOrder = getState().workOrder;

    dispatch(showAppBusy(true));
    return qwPartners
      .post(`/v1/work-orders/${workOrderNo}/duplicate`, {
        applianceId: appliance.applianceId,
      })
      .then(() => dispatch(fetchDuplicationStatus(true)))
      .catch((error) => {
        dispatch(showAppBusy(false));
        const errorDetails = error.response.data.errors[0].errorInfo;
        const message = errorDetails
          ? getErrorMessageForDuplication(errorDetails, appliance, workOrder)
          : `Failed with Status Code ${error.response.data.httpStatus}`;
        const errorInfo = {
          title: I18n.t('couldNotStartDuplication'),
          message,
        };
        dispatch(showAppError(errorInfo));
        dispatch(receiveAppliances(_.cloneDeep(appliances)));
      });
  };
};

export const fetchDuplicationStatus = (showLoading = false) => {
  return (dispatch, getState) => {
    const { appliances } = _.cloneDeep(getState().appliances);
    const account = getState().account;
    const partner = account.user && account.user.partner;

    dispatch(showAppBusy(showLoading));
    return qwPartners
      .get(`/v1/appliances/${partner.org}/duplication-status`)
      .then((res) => {
        const duplicationStatusAppliances = res.data;

        appliances.forEach((appliances) => {
          duplicationStatusAppliances.forEach((duplicateAppliances) => {
            if (appliances.applianceId === duplicateAppliances.applianceId) {
              appliances.drives = duplicateAppliances.drives;
            }
          });
        });

        dispatch(receiveAppliances(_.cloneDeep(appliances)));
        dispatch(updateActiveApplianceFromAppliances());
        dispatch(showAppBusy(false));
      })
      .catch((error) => {
        dispatch(showAppBusy(false));
        dispatch(handleAppError(error, I18n.t('unexpectedError')));
      });
  };
};

const reducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case RECEIVE:
      return update(state, { appliances: { $set: payload } });

    case UPDATE_ACTIVE_APPLIANCE:
      return update(state, { appliance: { $set: payload } });

    case IS_APPLIANCE_SWITCHED:
      return update(state, { isApplianceSwitched: { $set: payload } });

    case IS_APPLIANCE_STATUS_LOADING:
      return update(state, { isApplianceStatusLoading: { $set: payload } });

    default:
      return state;
  }
};

export default reducer;
